import { render, staticRenderFns } from "./UsersSupervisors.vue?vue&type=template&id=819464fc&scoped=true"
import script from "./UsersSupervisors.vue?vue&type=script&lang=js"
export * from "./UsersSupervisors.vue?vue&type=script&lang=js"
import style0 from "./UsersSupervisors.vue?vue&type=style&index=0&id=819464fc&prod&lang=scss&scoped=true"
import style1 from "./UsersSupervisors.vue?vue&type=style&index=1&id=819464fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819464fc",
  null
  
)

export default component.exports